import { view } from "@/mega-ui/helpers/function"
import { getAuthenticationStore } from "@/helpers/storeHelpers"
import { RouteLocationNormalized } from "vue-router"

export const consumption = {
    path: '/consumption',
    name: 'consumption',
    children: [
        {
            path: 'main',
            name: 'consumption-main',
            meta: {
                withAuth: true,
            },
            component: () => view('consumption/ConsumptionMainView')
        },
        {
            path: 'details',
            name: 'consumption-details',
            meta: {
                withAuth: true,
            },
            beforeEnter: (_to: RouteLocationNormalized, _from: RouteLocationNormalized) => {
                const authStore = getAuthenticationStore()
                if (authStore && authStore.isProRestriction) {
                    // BR-3364: temporarily disable pro restriction.
                    // return { name: 'consumption-main' }
                }
                
                return true
            },
            component: () => view('consumption/ConsumptionDetailsView')
        },
        {
            path: 'overspent',
            name: 'consumption-overspent-details',
            meta: {
                withAuth: true,
            },
            component: () => view('consumption/ConsumptionOverspentDetailsView')
        },
    ]
}